import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Quote, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import MMMediaCaseStudy, { CaseStudySection } from "@/components/MMMediaCaseStudy";
import { usFintechCaseStudy, healthcareSaasCaseStudy } from "@/data/caseStudies";

// Only owner-confirmed testimonials belong here. Do not add quotes, names,
// metrics or results without verified owner-supplied evidence.
const testimonials = [
  {
    quote: "Linkzy delivered exceptional results. Our organic traffic increased by 180% in just six months, and we're now ranking on page one for our most competitive keywords.",
    author: "Kim",
    role: "Marketing Director",
    company: usFintechCaseStudy.testimonial.company,
    metric: "+180% organic traffic",
  },
  {
    quote: "The quality of backlinks we received was outstanding. Every placement was on relevant, high-authority websites. This is the real deal. No shortcuts, just results.",
    author: "Sven",
    role: "CEO",
    company: "Valega",
    metric: "DA 60+ backlinks",
  },
  {
    quote: "Finally, a link building service that understands our industry. The team's strategic approach and transparent reporting gave us complete confidence in the process.",
    author: "Jonathan",
    role: "Head of SEO",
    company: "MM Media",
    metric: "+320% lead generation",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        {/* Testimonials */}
        <div className="mb-24">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground text-center mb-12">
            What Our Clients Say
          </h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((testimonial, index) => (
              <Card key={index} className="p-6 md:p-8 hover:shadow-xl transition-all duration-300 relative active:scale-[0.98]">
                <Quote className="w-8 h-8 md:w-10 md:h-10 text-primary/20 absolute top-5 right-5 md:top-6 md:right-6" />
                <div className="mb-5 md:mb-6">
                  <div className="inline-block px-3 py-1.5 md:px-4 md:py-2 bg-primary/10 rounded-full text-primary font-semibold text-xs md:text-sm mb-4">
                    {testimonial.metric}
                  </div>
                  <p className="text-foreground leading-relaxed italic text-sm md:text-base">
                    "{testimonial.quote}"
                  </p>
                </div>
                <div className="border-t border-border pt-5 md:pt-6">
                  <p className="font-semibold text-foreground text-sm md:text-base">{testimonial.author}</p>
                  <p className="text-xs md:text-sm text-muted-foreground">{testimonial.role}</p>
                  <p className="text-xs md:text-sm text-muted-foreground">{testimonial.company}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <MMMediaCaseStudy />
        </div>
        <div className="mb-16">
          <CaseStudySection study={usFintechCaseStudy} />
        </div>
        <div className="mb-16">
          <CaseStudySection study={healthcareSaasCaseStudy} />
        </div>

        {/* CTA */}
        <div className="max-w-3xl mx-auto">
          <Card className="p-8 md:p-12 text-center bg-primary text-primary-foreground border-0">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Want to see what links would do for your site?
            </h3>
            <p className="text-primary-foreground/80 mb-8 text-base md:text-lg">
              Get a free backlink gap analysis from Linkzy.
            </p>
            <Button asChild variant="hero" size="lg">
              <Link to="/contact">
                Get Your Free Analysis
                <ArrowRight className="ml-1" />
              </Link>
            </Button>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
